import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {WORD_BOOKMARK_API_URL} from '../../defines/protocol';
import {buildUrl, splitUrl} from "../../defines/common.func";
import {ApiService} from '../api/api.service';
import {WordService} from './word.service';


@Injectable({
  providedIn: 'root'
})
export class WordBookmarkService extends WordService {

  constructor(
    protected api: ApiService,
  ) {
    super(api);
    this.urlApi = WORD_BOOKMARK_API_URL;
  }

  /**
   * 현재 페이지에서 버퍼에 보충해야 할 항목의 수.
   * @protected
   */
  protected getReadCount(): number {
    // 현재 보관중인 속담의 개수가 pageSize의 배수가 아니면, 나머지를 채워준다.
    const page = Math.floor(this.getCurCount() / this.pageSize) + 1;
    const totalPage = Math.ceil(this.totalCount / this.pageSize);
    const left = page < totalPage ? this.pageSize : this.totalCount % this.pageSize;

    // 현재 보관중인 속담의 개수가 pageSize의 배수가 아니면, 나머지를 채워준다.
    const readCount = left - (this.getCurCount() % this.pageSize);

    // console.warn('WordBookmarkService::getItemCount()', readCount, left, totalPage, this.pageSize, page);

    return readCount;
  }

  /**
   * 단어를 책갈피에 추가/삭제하는 프로토콜을 서버에 전송한다.
   * 화면(listWord)와는 관계 없다.
   * @param id: 추가할 단어번호
   * @param add: 추가/삭제 여부
   */
  public sendBookmark(id: string, add: boolean = true): Observable<boolean> {
    const url = this.urlApi + id + '/';
    const obs = add ?
      this.api.Post(url, null) :
      this.api.Delete(url);

    return obs.pipe(
      map(data => {
        console.log('sendBookmark', id, add, data);
        return data;
      }),
      // catchError((err, caught) => {
      //   console.error('sendBookmark', id, add, err);
      //   throwError(err);
      //   return caught;
      // })
    );
  }

  /**
   * 지정한 단어를 표시 목록에서 제거한다.
   * this.listWord에서 제거하면 화면에서 지워진다.
   * @param id: 제거할 단어번호
   */
  public hideBookmark(id: string): void {
    const idx = this.listWord.findIndex(word => word.id === id);
    if (idx !== -1) {
      this.listWord.splice(idx, 1);
      this.mapWord.delete(id);
      --this.totalCount;

      if (this.nextUrl) {
        const {address, params} = splitUrl(this.nextUrl);

        const oldPage = params['page'];
        const page = Math.ceil((this.getCurCount() + 1) / this.pageSize);  // 페이지 단위 (pageSize)에 모자라면, 해당 페이지는 다시 받아야 함.

        params['page'] = page.toString();

        this.nextUrl = buildUrl(address, params);
      }
    }
    else {
      console.warn(`WordBookmarkService::hideBookmark(${id}) word does not exist`);
    }
  }

}
